import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "7cn5oo9j",
  dataset: "production",
});
